<template>
  <v-container id="homecard" fill-height>
    <v-row justify="center">
      <v-col cols="9" align="center">
        <v-img
          src="@/assets/iosper.svg"
          aspect-ratio="7" contain
          @click.prevent="$router.push('/prescribir')"
          style="opacity: 0.2;"
         >
        </v-img>
      </v-col>
    </v-row>
    <v-speed-dial
      v-model="fab"
      :bottom="true" :right="true" :top="false" :left="false"
      direction="top"
      transition="slide-x-reverse-transition"
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          color="warning"
          fab
        >
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            small
            color="warning"
            v-bind="attrs"
            v-on="on"
            @click.prevent="$router.push('/prescribir')"
          >
            <v-icon>mdi-grease-pencil</v-icon>
          </v-btn>
        </template>
        <span>Scan</span>
      </v-tooltip>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            small
            color="warning"
            v-bind="attrs"
            v-on="on"
            @click.prevent="$router.push('/prescripciones')"
          >
            <v-icon>mdi-playlist-check</v-icon>
          </v-btn>
        </template>
        <span>Ver prescripciones</span>
      </v-tooltip>
    </v-speed-dial>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'Home',

  data: () => ({
    fab: false,
  }),

  computed: {
    ...mapGetters({
      user: "user"
    })
  },
}
</script>

<style>
#homecard .v-speed-dial {
  position: absolute;
}

#homecard .v-btn--floating {
  position: relative;
}
</style>